import { track, TrackingEventName } from '@heidi/analytics/events';
import type { SessionCreatedEventProps } from '@heidi/session/contracts';

export const trackSessionCreated = (props: SessionCreatedEventProps): void => {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.SessionCreated,
    props,
  });
};
